import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Button, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import InputBase from "@mui/material/InputBase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { format, parseISO } from "date-fns";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import WelcomeNameContainer from "../../LaunchComponent/WelcomeNameContainer";
import {
 fetchCampaignsData,
 handleCampainIDSelection,
 resetSubmissionButton,
} from "../../Redux/Mailer";
import {
 fetchNonCampignMails,
 handleFetchProgramNames,
 handleGenerateVivaNudge,
 handleGenerateVivaNudgeNewContent,
 handleVivaLoadingNudge,
} from "../../Redux/Viva";
import VivaDisplayPage from "./vivaDisplayPage";
const WhiteBorderTextField = styled(TextField)(({ theme }) => ({
 " & label.Mui-focused": {
  color: " #a804ff",
 },
 " & .MuiOutlinedInput-root": {
  padding: "8.5px 12px  !important",
  "&.Mui-focused fieldset": {
   borderColor: "#a814ff",
   borderWidth: "1px",
  },
 },
 "& .MuiInputBase-input": {
  // Use the system font instead of the default Roboto font.
  fontFamily: ["Graphik-Regular"],
  fontSize: "14px",
 },
 "& .MuiInputBase-root-MuiOutlinedInput-root": {
  padding: "1px 2px !important",
 },
}));
const CustomRadio = styled(Radio)(({ theme }) => ({
 "&.Mui-checked": {
  color: "#9c27b0", // Purple for the checked state
 },
 "& .MuiSvgIcon-root": {
  fontSize: "1.5rem", // Custom icon size
 },
 "&:hover": {
  backgroundColor: "rgba(156, 39, 176, 0.08)", // Optional hover effect
 },
}));
const BootstrapInput = styled(InputBase)(({ theme }) => ({
 "label + &": {
  marginTop: theme.spacing(3),
 },
 "& .MuiInputBase-input": {
  borderRadius: 4,
  position: "relative",
  backgroundColor: theme.palette.background.paper,
  border: "1px solid #ced4da",
  fontSize: 14,
  padding: "9px 26px 9px 12px",

  transition: theme.transitions.create(["border-color", "box-shadow"]),
  // Use the system font instead of the default Roboto font.
  fontFamily: ["Graphik-Regular"],
 },
}));
const NudgeMailForm = ({
 mailerChild,
 setMailerChild,
 setMailerParent,
 mailerParent,
}) => {
 const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
   backgroundColor: "#f5f5f9",
   color: "rgba(0, 0, 0, 0.87)",
   maxWidth: 220,
   fontSize: theme.typography.pxToRem(12),
   border: "1px solid #dadde9",
  },
 }));
 const [programNameViva, setprogramNameViva] = useState("");
 const [campaign, setCampaign] = useState(0);
 const [programName, setProgramName] = useState("");
 const [uniqueID, setUniqueID] = useState("");

 const [contentCategory, setContentCategory] = useState("");
 const [programDateViva, setProgramDateViva] = useState(null);
 const [isMailGeneratedVivaLaunch, setIsMailGeneratedVivaLaunch] = useState("");
 const [keyMessageViva, setKeyMessageViva] = useState("");
 const [mailerStatus, setMailerStatus] = useState("");
 const campaignList = useSelector((state) => state.model.campaignList);
 const options =
  campaignList.message !== "No campaign for this user." && campaignList.length > 0
   ? campaignList.map((item) => ({ id: item.id, name: item.name }))
   : [];
 const programDetails = useSelector((state) => state.viva.programDetails);
 const programOptions =
  programDetails.length > 0
   ? programDetails.map((item) => ({
      programname: item.programname,
      uniqueID: item.uniqueID,
      category: item.category,
     }))
   : [];
 const [isVivaLaunchMailGenerationClicked, setIsVivaLaunchGenerationClicked] =
  React.useState(false);
 const [isVivaNavigatedToForm, setIsVivaNavigatedToForm] = useState(false);
 const handleRadioChange = (e) => {
  setCategoryName(e.target.value);
  dispatch(fetchCampaignsData(e.target.value));
  setValue("");
  handleRadioChangeReset();
 };
 const isMailLoaded = useSelector((state) => state.viva.isVivaLoadedNudge);
 const mailData = useSelector((state) => state.viva.mailDataNudge);
 const [categoryName, setCategoryName] = useState("Program");
 const dispatch = useDispatch();
 const handleContentCategory = (event) => {
  setContentCategory(event.target.value);
  setIsMailGeneratedVivaLaunch("init");
 };

 const handleVivaMailGeneration = () => {
  setIsVivaLaunchGenerationClicked(true);
  if (mailerStatus == "yes") {
   let values = {
    programNameViva: programName,
    uniqueID: uniqueID,
    contentCategory: contentCategory,
    currentContent: "",
    sessionID: localStorage.getItem("sessionId"),
   };
   dispatch(handleGenerateVivaNudge(values));
  } else {
   let values = {
    programNameViva: programNameViva,
    uniqueID: uniqueID,
    contentCategory: contentCategory,
    currentContent: "",
    sessionID: localStorage.getItem("sessionId"),
    launchDate: programDateViva,
    keyMessage: keyMessageViva,
    categoryName: categoryName,
    userquery: "",
   };
   dispatch(handleGenerateVivaNudgeNewContent(values));
  }
 };
 const handleReset = () => {
  dispatch(resetSubmissionButton());

  setMailerChild("");
  setMailerParent("");
  setCategoryName("Program");
  setProgramDateViva("");
  setContentCategory("");
  setKeyMessageViva();
  setprogramNameViva("");
 };
 const handleCampaignID = (value) => {
  if (value) {
   setCampaign(value.id);
   let campaignID = value.id;
   dispatch(handleCampainIDSelection(campaignID));
   let val = "Nudge";

   dispatch(handleFetchProgramNames(campaignID, val));
  }
 };
 useEffect(() => {
  dispatch(fetchCampaignsData(categoryName));
 }, []);
 const handleProgramName = (value) => {
  if (value) {
   setProgramName(value.programname);
   let selected = programDetails.filter((item) => item.programname == value.programname);
   setUniqueID(selected[0].uniqueID);
   setIsMailGeneratedVivaLaunch("init");
  }
 };
 const [value, setValue] = React.useState(null);

 const handleChange = (event) => {
  if (event.target.value == "no") {
   setCampaign(0);
   dispatch(handleCampainIDSelection(0));
  }
  handleRadioChangeReset();

  setValue(event.target.value);
 };
 const handleChangeMailerStatus = (event) => {
  setMailerStatus(event.target.value);
  setContentCategory("");
  setProgramName("");
  setKeyMessageViva("");
  setProgramDateViva("");
  setprogramNameViva("");
  if (event.target.value == "no" && value == "yes") {
   let data;
   data = campaignList.filter((val) => val.id == campaign);
   setprogramNameViva(data[0].name);

   const endDateItem = data[0].selectedItems.filter(
    (val) => val.title == "Learning Journey End"
   );
   let learningJourneyEnd;
   if (endDateItem.length != 0) {
    learningJourneyEnd = format(parseISO(endDateItem[0].date), "yyyy-MM-dd");
   } else {
    learningJourneyEnd = "";
   }
   setProgramDateViva(learningJourneyEnd);
  }
  if (event.target.value == "yes" && value == "no") {
   dispatch(fetchNonCampignMails("Nudge", categoryName));
  }
 };
 const handleRadioChangeReset = () => {
  setProgramDateViva("");
  setProgramName("");
  setMailerStatus("");
  setContentCategory("");
  setKeyMessageViva();
  dispatch(resetSubmissionButton());
  setIsMailGeneratedVivaLaunch("init");
  setIsVivaNavigatedToForm(false);
 };
 return (
  <>
   {!isVivaLaunchMailGenerationClicked ? (
    <Stack sx={{ width: "100%" }} spacing={10}>
     <Stack sx={{ height: "20px" }}>
      <WelcomeNameContainer currentComp="Viva-Engage-Nudge" />
     </Stack>
     <Stack spacing={4} sx={{ paddingLeft: "30px", marginTop: "60px !important" }}>
      <div className="mailer-form-categories-section">
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Learning Program</span>
        <input
         type="radio"
         checked={categoryName === "Program"}
         value="Program"
         name="radio-category"
         onChange={handleRadioChange}
        />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Event</span>
        <input
         type="radio"
         checked={categoryName === "Event"}
         value="Event"
         name="radio-category"
         onChange={handleRadioChange}
        />
        <span class="mailer-form-categories-checkmark"></span>
       </label>

       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Webinar</span>
        <input
         type="radio"
         checked={categoryName === "Webinar"}
         value="Webinar"
         name="radio-category"
         onChange={handleRadioChange}
        />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
      </div>
      <Stack direction={"column"} sx={{ alignItems: "flex-start" }} spacing={2}>
       <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this communication part of any campaign?
          <span style={{ color: "red" }}>*</span>
         </Typography>
         <Typography>(If yes, select the campaign name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={value}
          onChange={handleChange}
          sx={{ paddingLeft: "20px" }}
         >
          <FormControlLabel
           value="yes"
           control={
            <CustomRadio
             icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
             checkedIcon={
              <CheckCircleOutlineIcon style={{ fontSize: "1.3rem", color: "#9c27b0" }} />
             } // Checkmark inside circle when checked
            />
           }
           label="Yes"
          />
          <FormControlLabel
           value="no"
           control={
            <CustomRadio
             icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
             checkedIcon={
              <CheckCircleOutlineIcon style={{ fontSize: "1.3rem", color: "#9c27b0" }} />
             } // Checkmark inside circle when checked
            />
           }
           label="No"
          />
         </RadioGroup>
        </FormControl>
       </Stack>
       {value == "yes" && (
        <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
         <Typography>
          Select the campaign <span style={{ color: "red" }}>*</span>
         </Typography>
         <Stack
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
           m: 1,
           width: "300px",
           mt: 3,
          }}
          direction={"row"}
          spacing={2}
         >
          {/* <Select input={<BootstrapInput />} value={campaign} onChange={handleCampaignID}>
           {campaignList.message != "No campaign for this user." &&
            campaignList.length > 0 &&
            campaignList.map((item, index) => (
             <MenuItem key={index + 1} value={item.id}>
              {item.name}
             </MenuItem>
            ))}
          </Select> */}
          <Autocomplete
           value={options.find((option) => option.id === campaign) || null}
           onChange={(event, newValue) => {
            handleCampaignID(newValue);
           }}
           options={options}
           getOptionLabel={(option) => option.name || ""}
           ListboxProps={{
            style: {
             maxHeight: "150px", // Fixed height for the dropdown
             overflowY: "auto", // Enable vertical scrolling
            },
           }}
           renderInput={(params) => (
            <TextField
             sx={{ "& .MuiOutlinedInput-root": { padding: "2px !important" } }}
             {...params}
             variant="outlined"
            />
           )}
           filterSelectedOptions={false}
          />
         </Stack>
        </Stack>
       )}
      </Stack>
      <Stack direction={"column"} sx={{ alignItems: "flex-start" }} spacing={2}>
       <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this part of a Mailer?
          <span style={{ color: "red" }}>*</span>
         </Typography>
         <Typography>(If yes, select the program name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={mailerStatus}
          onChange={handleChangeMailerStatus}
          sx={{ paddingLeft: "20px" }}
         >
          <FormControlLabel
           value="yes"
           control={
            <CustomRadio
             icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
             checkedIcon={
              <CheckCircleOutlineIcon style={{ fontSize: "1.3rem", color: "#9c27b0" }} />
             } // Checkmark inside circle when checked
             disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            />
           }
           label="Yes"
          />
          <FormControlLabel
           value="no"
           control={
            <CustomRadio
             icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
             checkedIcon={
              <CheckCircleOutlineIcon style={{ fontSize: "1.3rem", color: "#9c27b0" }} />
             } // Checkmark inside circle when checked
             disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            />
           }
           label="No"
          />
         </RadioGroup>
        </FormControl>
       </Stack>
       {mailerStatus == "yes" && (
        <Stack direction={"row"} spacing={2}>
         {" "}
         <Stack direction={"row"} sx={{ alignItems: "end" }} spacing={2}>
          <Typography>
           Select the program name <span style={{ color: "red" }}>*</span>
          </Typography>
          <Stack
           sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
            m: 1,
            width: "300px",
            mt: 3,
           }}
           direction={"row"}
           spacing={2}
          >
           {/* <Select
            input={<BootstrapInput />}
            value={programName}
            onChange={handleProgramName}
           >
            {programDetails.length > 0 &&
             programDetails.map((item, index) => (
              <MenuItem key={index + 1} value={item.programname}>
               {item.programname}
              </MenuItem>
             ))}
           </Select> */}
           <Autocomplete
            value={
             programOptions.find((option) => option.programname === programName) || null
            }
            onChange={(event, newValue) => {
             handleProgramName(newValue);
            }}
            options={programOptions}
            getOptionLabel={(option) => option.programname || ""}
            ListboxProps={{
             style: {
              maxHeight: "150px", // Fixed height for the dropdown
              overflowY: "auto", // Enable vertical scrolling
             },
            }}
            renderInput={(params) => (
             <TextField
              sx={{ "& .MuiOutlinedInput-root": { padding: "2px !important" } }}
              {...params}
              variant="outlined"
             />
            )}
            filterSelectedOptions={false}
           />
          </Stack>
         </Stack>
         <Stack spacing={0.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
           <Typography sx={{ fontSize: "14px", fontFamily: "Graphik-Medium" }}>
            Category<span style={{ color: "red" }}>*</span>
           </Typography>
           <HtmlTooltip
            arrow
            title={<React.Fragment>Select the content category </React.Fragment>}
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{
              width: "15px",
              height: "15px",
              cursor: "pointer",
             }}
            ></img>
           </HtmlTooltip>
          </Stack>
          <Stack
           sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
            m: 1,
            width: "300px",
            mt: 3,
           }}
           direction={"row"}
           spacing={2}
          >
           <Select
            input={<BootstrapInput />}
            value={contentCategory}
            onChange={handleContentCategory}
            // MenuProps={MenuProps}
            disabled={
             mailerStatus == null || (mailerStatus == "yes" && programName == "")
              ? true
              : false
            }
           >
            <MenuItem key={0} value={1}>
             Post content/Caption
            </MenuItem>
            <MenuItem key={1} value={2}>
             Creative content/Image copy
            </MenuItem>
            <MenuItem key={2} value={3}>
             All of the above
            </MenuItem>
           </Select>
          </Stack>
         </Stack>
        </Stack>
       )}
      </Stack>
      {mailerStatus == "no" ? (
       <Stack direction={"column"} spacing={2} alignItems={"center"}>
        <Grid container spacing={2}>
         <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography
             sx={{
              fontSize: "14px",
              fontFamily: "Graphik-Medium",
             }}
            >
             Name<span style={{ color: "red" }}>*</span>
            </Typography>
            <HtmlTooltip
             arrow
             title={
              <React.Fragment>
               {" "}
               {categoryName == "Program" ? (
                <p> Enter the program name </p>
               ) : categoryName == "Event" ? (
                <p> Enter the event name</p>
               ) : (
                <p> Enter the Webinar name</p>
               )}
              </React.Fragment>
             }
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{
               width: "15px",
               height: "15px",
               cursor: "pointer",
              }}
             ></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField
            placeholder={
             categoryName == "program"
              ? "e.g: Java Full Stack"
              : categoryName == "event"
              ? "e.g: Google Cloud Fusion Fest"
              : categoryName == "webinars"
              ? "e.g: Azure Open AI Security"
              : "e.g: HMM Spark"
            }
            id="multiline"
            multiline
            InputLabelProps={{ shrink: false }}
            minRows={1}
            //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            //  maxRows={2}
            InputProps={{
             readOnly: value === "yes" && campaign != 0,
            }}
            onChange={(event) => {
             setprogramNameViva(event.target.value);
             setIsMailGeneratedVivaLaunch("init");
            }}
            fullWidth
            sx={{
             fontFamily: "Graphik-Regular",
             padding: "6px,10px",
            }}
            value={programNameViva}
           />
          </Stack>
         </Grid>
         <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography
             sx={{
              fontSize: "14px",
              fontFamily: "Graphik-Medium",
             }}
            >
             Category<span style={{ color: "red" }}>*</span>
            </Typography>
            <HtmlTooltip
             arrow
             title={<React.Fragment>Select the content category </React.Fragment>}
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{
               width: "15px",
               height: "15px",
               cursor: "pointer",
              }}
             ></img>
            </HtmlTooltip>
           </Stack>
           <Stack
            sx={{
             display: "flex",
             flexDirection: "column",
             gap: "10px",
             marginBottom: "10px",
             m: 1,
             width: "200",
             mt: 3,
            }}
            direction={"row"}
            spacing={2}
           >
            <Select
             input={<BootstrapInput />}
             value={contentCategory}
             onChange={handleContentCategory}
             // MenuProps={MenuProps}
             // disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            >
             <MenuItem key={0} value={1}>
              Post content/Caption
             </MenuItem>
             <MenuItem key={1} value={2}>
              Creative content/Image copy
             </MenuItem>
             <MenuItem key={2} value={3}>
              All of the above
             </MenuItem>
            </Select>
           </Stack>
          </Stack>
         </Grid>
         <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography
             sx={{
              fontSize: "14px",
              fontFamily: "Graphik-Medium",
             }}
            >
             Key Date<span style={{ color: "red" }}>*</span>
            </Typography>
            <HtmlTooltip
             arrow
             title={
              <React.Fragment>
               {" "}
               <p> Specify the final date of completion. </p>
              </React.Fragment>
             }
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{
               width: "15px",
               height: "15px",
               cursor: "pointer",
              }}
             ></img>
            </HtmlTooltip>
           </Stack>
           <input
            type="date"
            className="maindate"
            style={{ padding: "11px" }}
            onChange={(event) => {
             setProgramDateViva(event.target.value);
             setIsMailGeneratedVivaLaunch("init");
            }}
            //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            value={programDateViva}
            readOnly={
             value == "yes" && campaign != 0 && programDateViva != "" ? true : false
            }
            onKeyDown={(e) => e.preventDefault()}
           />
          </Stack>
         </Grid>
        </Grid>
        <Grid container spacing={2}>
         <Grid item xs={6}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography
             sx={{
              fontSize: "14px",
              fontFamily: "Graphik-Medium",
             }}
            >
             Key Message<span style={{ color: "red" }}>*</span>
            </Typography>
            <HtmlTooltip
             arrow
             title={
              <React.Fragment>
               {categoryName == "Program" ? (
                <p>
                 Provide key details or actions to be taken (e.g., complete learning
                 journey/assignment, take assessment, book exam, participate in quiz, and
                 more).
                </p>
               ) : categoryName == "Event" ? (
                <p>
                 Provide key details or actions to be taken (e.g., attend the event,
                 participate in quiz, and more).
                </p>
               ) : (
                <p>
                 Provide key details or actions to be taken (e.g., attend the event,
                 participate in quiz, and more).
                </p>
               )}
              </React.Fragment>
             }
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{
               width: "15px",
               height: "15px",
               cursor: "pointer",
              }}
             ></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField
            placeholder={
             categoryName == "program"
              ? "e.g: Certificate of Participation given for participating in a learning program."
              : categoryName == "event"
              ? "e.g:  Certificate of Participation given for participating in an event."
              : categoryName == "webinars"
              ? "e.g: Certificate of Participation given for participating in a webinar."
              : "e.g: Certificate of Achievement for an exceptional role in developing a microsite/tool/platform."
            }
            id="outlined-multiline-flexible"
            multiline
            maxRows={3}
            minRows={3}
            //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            onChange={(event) => {
             setKeyMessageViva(event.target.value);
             setIsMailGeneratedVivaLaunch("init");
            }}
            fullWidth
            sx={{
             fontFamily: "Graphik-Regular",
             padding: "6px,10px",
            }}
            value={keyMessageViva}
           />
          </Stack>
         </Grid>
        </Grid>
        <Stack
         justifyContent={"center"}
         alignItems={"center"}
         direction={"row"}
         spacing={2}
        >
         {isVivaNavigatedToForm && (
          <Button
           sx={{
            border: "1px solid #d3d3d3",
            borderRadius: "5px",
            padding: "10px",
            width: "150px",
            alignItems: "center",
            width: "150px",
            background: "#fff",
            color: "#a814ff",
            textTransform: "none",
            fontFamily: "Graphik-Medium",
           }}
           onClick={() => {
            setIsVivaLaunchGenerationClicked(true);
            setIsMailGeneratedVivaLaunch("generateOutput");
           }}
          >
           Next
          </Button>
         )}
         {isMailGeneratedVivaLaunch !== "init" ||
         programDateViva == "" ||
         programNameViva == "" ||
         keyMessageViva == "" ||
         contentCategory == "" ? (
          <Stack
           direction={"row"}
           spacing={1}
           sx={{
            border: "2px solid #8a2be2",
            borderRadius: "28px",
            padding: " 4px 0 4px 6px",
            width: "150px",
            alignItems: "center",
            width: "150px",
            pointerEvents: "none",
            opacity: " 0.4",
           }}
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}
            style={{ width: "35px", height: "35px" }}
           ></img>
           <span style={{ fontSize: "18px" }}>Generate</span>
          </Stack>
         ) : (
          <Stack
           direction={"row"}
           spacing={1}
           sx={{
            border: "2px solid #8a2be2",
            borderRadius: "28px",
            padding: " 4px 0 4px 6px",
            width: "150px",
            alignItems: "center",
            width: "150px",
            cursor: "pointer",
           }}
           onClick={() => {
            handleVivaMailGeneration();
            setIsMailGeneratedVivaLaunch("generateOutput");
            dispatch(handleVivaLoadingNudge());
           }}
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}
            style={{ width: "35px", height: "35px" }}
           ></img>

           <span style={{ fontSize: "18px" }}>Generate</span>
          </Stack>
         )}
        </Stack>
       </Stack>
      ) : mailerStatus == "yes" ? (
       <Stack spacing={4}>
        <Stack
         justifyContent={"center"}
         alignItems={"center"}
         direction={"row"}
         spacing={2}
        >
         {isVivaNavigatedToForm && (
          <Button
           sx={{
            border: "1px solid #d3d3d3",
            borderRadius: "5px",
            padding: "10px",
            width: "150px",
            alignItems: "center",
            width: "150px",
            background: "#fff",
            color: "#a814ff",
            textTransform: "none",
            fontFamily: "Graphik-Medium",
           }}
           onClick={() => {
            setIsVivaLaunchGenerationClicked(true);
            setIsMailGeneratedVivaLaunch("generateOutput");
           }}
          >
           Next
          </Button>
         )}
         {isMailGeneratedVivaLaunch !== "init" ||
         mailerStatus == null ||
         (mailerStatus == "yes" && programName == "") ||
         contentCategory == "" ? (
          <Stack
           direction={"row"}
           spacing={1}
           sx={{
            border: "2px solid #8a2be2",
            borderRadius: "28px",
            padding: " 4px 0 4px 6px",
            width: "150px",
            alignItems: "center",
            width: "150px",
            pointerEvents: "none",
            opacity: " 0.4",
           }}
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}
            style={{ width: "35px", height: "35px" }}
           ></img>
           <span style={{ fontSize: "18px" }}>Generate</span>
          </Stack>
         ) : (
          <Stack
           direction={"row"}
           spacing={1}
           sx={{
            border: "2px solid #8a2be2",
            borderRadius: "28px",
            padding: " 4px 0 4px 6px",
            width: "150px",
            alignItems: "center",
            width: "150px",
            cursor: "pointer",
           }}
           onClick={() => {
            handleVivaMailGeneration();
            setIsMailGeneratedVivaLaunch("generateOutput");
            dispatch(handleVivaLoadingNudge());
           }}
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}
            style={{ width: "35px", height: "35px" }}
           ></img>

           <span style={{ fontSize: "18px" }}>Generate</span>
          </Stack>
         )}
        </Stack>
       </Stack>
      ) : null}
     </Stack>
    </Stack>
   ) : (
    <VivaDisplayPage
     mailerChild={mailerChild}
     mailerParent={mailerParent}
     programName={programName}
     programNameViva={programNameViva}
     categoryName={categoryName}
     handleReset={handleReset}
     setIsMailGeneratedVivaLaunch={setIsMailGeneratedVivaLaunch}
     setIsVivaLaunchGenerationClicked={setIsVivaLaunchGenerationClicked}
     setIsVivaNavigatedToForm={setIsVivaNavigatedToForm}
     mailerStatus={mailerStatus}
     isMailLoaded={isMailLoaded}
     mailData={mailData}
    />
   )}
  </>
 );
};

export default NudgeMailForm;
